import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import AddEditSupplierProductDensitiesForm from './AddEditSupplierProductDensities';

function AddEditModal({
  row,
  mode,
  onSave,
  onCancel,
  onDelete,
  open,
  ...rest
}) {
  return (
    <Dialog maxWidth="sm" fullWidth onClose={onCancel} open={open} {...rest}>
      {/* Dialog renders its body even if not open */}
      {open && (
        <AddEditSupplierProductDensitiesForm
          row={row}
          mode={mode}
          onSave={onSave}
          onCancel={onCancel}
          onDelete={onDelete}
        />
      )}
    </Dialog>
  );
}

AddEditModal.propTypes = {
  row: PropTypes.object,
  mode: PropTypes.oneOf(['add', 'edit']),
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool,
};

AddEditModal.defaultProps = {
  row: {},
  onSave: () => {},
  onCancel: () => {},
  onDelete: () => {},
  open: false,
};

export default AddEditModal;
